export const SPECIAL_EVENT_CODE = 'special_event'
export const BLACKOUT_DATE_CODE = 'blackout_date'
